/**
 * 图像加载器相关常量配置
 */

/** 最大分辨率验证错误消息 */
export const INVALID_MAX_RESOLUTION_ERROR = '最大分辨率必须为正数';

/** 2D渲染上下文获取错误消息 */
export const CANVAS_CONTEXT_ERROR = '无法获取2D渲染上下文';

/** 图像源验证错误消息 */
export const INVALID_IMAGE_SOURCE_ERROR = '图像源必须为有效的字符串';

/** 图像加载错误消息模板 */
export const IMAGE_LOAD_ERROR_TEMPLATE = '无法加载图像: {src}';